<template>
  <v-dialog
    v-if="needRefresh"
    v-model="dialog"
    location="bottom center"
    class="start-prompt"
  >
    <v-container>
      <v-row class="align-right justify-center">
        <v-col cols="12" md="6" sm="8" xs="12" class="modal-background">
          <v-card>
            <v-card-text>
              <h3 class="text-h4">Leerstandsmelder-App</h3>
              <div class="text-h6">
                <span v-if="needRefresh">
                  {{ $t("actions.update_available") }}
                </span>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="needRefresh"
                class="action-primary"
                color="primary"
                variant="outlined"
                @click="UpdateAndClose()"
              >
                <v-icon>$mdiRefresh</v-icon>
                {{ $t("actions.reload") }}
              </v-btn>
              <v-btn color="primary" variant="outlined" @click="close">
                <v-icon>$mdiClose</v-icon>
                {{ $t("actions.close") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
  <!-- v-icon v-if="offlineReady" icon="$mdiInformation"></v-icon-->
</template>

<script setup>
import { ref } from "vue";
import { useRegisterSW } from "virtual:pwa-register/vue";

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW();

const close = async () => {
  offlineReady.value = false;
  needRefresh.value = false;
  dialog.value = false;
};
const UpdateAndClose = async () => {
  updateServiceWorker();
  offlineReady.value = false;
  needRefresh.value = false;
  dialog.value = false;
};
const dialog = ref(needRefresh);
</script>
